// import moment from 'moment';
import config from '../../config';
import { get, post } from './base/index';

export default {
  getTodoData: data => new Promise((resolve) => {
    const params = { ...data };
    console.log(JSON.stringify(params));
    resolve(get(`${config.serverUrl}/management/todo`, { params }));
  }),
  setTodoData: (body, data) => new Promise((resolve) => {
    const params = { ...data };
    resolve(post(`${config.serverUrl}/management/todo`, body, { params }));
  }),
};
